import localStorageEnum from '../enums/localStorageEnum'
import { configEnum } from '../enums/fetchFactoryEnum'
import { logoutPostModel } from '../types/logout/logoutModel'
import { SPACE } from '../modules/changementAppartement/components/FormulaireChangementAppartement'

const ID_TOKEN: string = 'id_token'
const ACCESS_TOKEN: string = 'accessToken'

const logout = (removeCookies: any) => {
	const dataLogout: logoutPostModel = {
		id_token: JSON.parse(localStorage.getItem(localStorageEnum.oktaToken) || '').accessToken.id_token || '',
		redirect: JSON.parse(localStorage.getItem(localStorageEnum.commonUri) || '').login_uri || ''
	}
	fetch(`/api/ec_${process.env.REACT_APP_TARGET}/okta/logout`,
		{
			body: JSON.stringify(dataLogout),
			method: configEnum.post
		})
		.then((response: Response) => response.json()
			.then(
				(logoutResponse: any) => {
					clearStorage(removeCookies)

					window.location.href = logoutResponse.url
				}
			)
		)
}

export const clearStorage = (removeCookies: any) => {
	localStorage.removeItem(localStorageEnum.user)
	localStorage.removeItem(localStorageEnum.residences)
	localStorage.removeItem(localStorageEnum.buildings)
	localStorage.removeItem(localStorageEnum.oktaToken)
	localStorage.removeItem(localStorageEnum.language)

	removeCookies(ID_TOKEN, {
		path: '/',
		domain: JSON.parse(localStorage.getItem('commonUri') || '').cookie_domain || ''
	})
	removeCookies(ACCESS_TOKEN, {
		path: '/',
		domain: JSON.parse(localStorage.getItem('commonUri') || '').cookie_domain || ''
	})
	removeCookies(SPACE, {
		path: '/',
		domain: JSON.parse(localStorage.getItem('commonUri') || '').cookie_domain || ''
	})
}

export default logout